import React, { useContext, useState } from "react";
import { LanguageContext, text } from "../../container/language";

import "./style.scss";

import { useStaticQuery } from "gatsby";
import { usePageContext } from "../../utils/PageContext";
import Paragraphs from "../Article/Paragraphs";

export const query = graphql`
  query {
    api {
      configSiteMessage {
        isActive
        type
        title {
          text_sq
          text_en
        }
        body {
          text_sq
          text_en
        }
      }
    }
  }
`;

const SystemMessages = () => {
  const data = useStaticQuery(query);
  const { lang } = usePageContext();
  const [isExpanded, setExpanded] = useState(false);

  const message = data.api.configSiteMessage;

  if (!message.isActive) {
    return null;
  }

  return (
    <div className="system-message-wrapper">
      <div
        className={`system-message system-message--${message.type}`}
        style={{ display: isExpanded ? "block" : "none" }}
      >
        <div className="wrapper">
          <p>
            <span className="system-message__title">
              <font>
                <font>{text(message.title, lang)}</font>
              </font>
            </span>
          </p>

          <Paragraphs data={message.body} className="a" />

          <button
            type="button"
            className="system-message__close"
            onClick={() => setExpanded(false)}
          >
            <span>
              <font>
                <font>Close</font>
              </font>
            </span>
            <i className="i-multiply"> </i>
          </button>
        </div>
      </div>

      <div className="wrapper relative-position">
        <button
          className="system-message__show js-system-message-show system-message--info"
          style={{ display: !isExpanded ? "block" : "none" }}
          onClick={() => setExpanded(true)}
        ></button>
      </div>
    </div>
  );
};

export default SystemMessages;
